import { z } from "zod";
import { asManagedProfileId, asUserId, ok } from "@pack-it-up/shared";
import { firestoreTimestamp, parseDto, toTimestamp } from "./common.js";
export const ManagedProfileDtoSchema = z.object({
    id: z.string(),
    displayName: z.string(),
    photoUrl: z.string().optional(),
    guardianUserIds: z.array(z.string()),
    upgradedToUserId: z.string().optional(),
    createdAt: firestoreTimestamp(),
});
export const toDomainManagedProfile = (raw) => {
    const p = parseDto(ManagedProfileDtoSchema, raw, "ManagedProfile");
    if (!p.ok)
        return p;
    const d = p.value;
    return ok({
        id: asManagedProfileId(d.id),
        displayName: d.displayName,
        ...(d.photoUrl !== undefined ? { photoUrl: d.photoUrl } : {}),
        guardianUserIds: d.guardianUserIds.map((g) => asUserId(g)),
        ...(d.upgradedToUserId !== undefined ? { upgradedToUserId: asUserId(d.upgradedToUserId) } : {}),
        createdAt: d.createdAt,
    });
};
export const toManagedProfileDto = (m) => ({
    id: m.id,
    displayName: m.displayName,
    ...(m.photoUrl !== undefined ? { photoUrl: m.photoUrl } : {}),
    guardianUserIds: m.guardianUserIds,
    ...(m.upgradedToUserId !== undefined ? { upgradedToUserId: m.upgradedToUserId } : {}),
    createdAt: toTimestamp(m.createdAt),
});
//# sourceMappingURL=managedProfile.mapper.js.map